import React from "react"
import team1 from "../../images/team/Ram-Evrchat-CEO.jpg"
import team2 from "../../images/team/Adrian-Evrchat-CTO.jpg"
import team3 from "../../images/team/James-Pickering-COO-Evrchat.png"
import team4 from "../../images/team/Stuart-Henderson-Evrchat.jpg"


const TeamMember = () => {
  return (
    <>
      <section className="scientist-area pt-50">
        <div className="container">
          <div className="section-title2">
            <h3>Executive Team</h3>
          </div>

         <div className="row">
            <div className="col-lg-3 col-sm-6 col-12">
              <div className="single-scientist-item-box">
                <div className="image">
                  <img src={team1} alt="team" className="team-img" />
                  <ul className="social">
                    <li>
                      <a
                        href="https://www.linkedin.com/in/ram-hemmige"
                        className="d-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="bx bxl-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="content">
                  <h3>Ram Hemmige</h3>
                  <p>Founder <br />
                  Chief Executive Officer</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-12">
              <div className="single-scientist-item-box">
                <div className="image">
                  <img src={team2} alt="team" className="team-img" />
                  <ul className="social">
                    <li>
                      <a
                        href="https://www.linkedin.com/in/adriansmith2"
                        className="d-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="bx bxl-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="content">
                  <h3>Adrian Smith</h3>
                  <p>Co-founder <br />
                  Chief Technology Officer</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-12">
              <div className="single-scientist-item-box">
                <div className="image">
                  <img src={team3} alt="team" className="team-img" />
                  <ul className="social">
                    <li>
                      <a
                        href="https://www.linkedin.com/in/pickering/"
                        className="d-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="bx bxl-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="content">
                  <h3>James Pickering</h3>
                  <p>Chief Operating Officer <br />
                  Chief Revenue Officer</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 col-12">
              <div className="single-scientist-item-box">
                <div className="image">
                  <img src={team4} alt="team" className="team-img" />
                  <ul className="social">
                    <li>
                      <a
                        href="https://www.linkedin.com/in/stu-henderson-91309028/"
                        className="d-block"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="bx bxl-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="content">
                  <h3>Stuart Henderson</h3>
                  <p>Customer Success Manager</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TeamMember
